import { startCase, camelCase } from "lodash";

export default class Transform {
  public toTitleCase(str: string): string {
    return startCase(camelCase(str));
  }

  public toLocalDate(str: string): string {
    return new Date(str).toLocaleString("en-AU");
  }

  public removeNewLines(str: string): string {
    return str.replace(/\w*\n/, ", ");
  }

  public distance(startCoords: number[], endCoords: number[]): string {
    const distance =
      Math.sqrt(
        (startCoords[0] - endCoords[0]) ** 2 +
          (startCoords[1] - endCoords[1]) ** 2
      ) * 111.1111;
    return `${Math.round(distance * 100) / 100} km away`;
  }
}
